export const AdFree = ({ width = 20, height = 20, ...props }: any) => (
  <img src="/icons/AdFree.svg" alt="AD-Free" width={width} height={height} {...props} />
)
